import React from 'react'

import Widget from '../Widget'
import CustomerMap from '../components/CustomerMap'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'
import withFetch from '../../../infrastructure/withFetch'

import fullscreen from './fullscreen.png'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/visits/get-locations/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry, event }) => (
        <Widget data={data} status={status} retry={retry}>
            <CustomerMap data={data} event={event} />
        </Widget>
    ),
)

const tooltip = (
    <div>
        <p>
            Select <img src={fullscreen} alt="fullscreen" width={20} /> to view
            the map full screen, then press the escape key to exit full screen.
        </p>
        <p>
            Numbers on map are unique browsers where we know their location.
            This is most commonly where we have been able to match a visitor to
            an Oztix customer account holder for whom we have an address on
            file.
        </p>
        <p>
            Use your mouse wheel or the +/- icons to zoom in or out. You may
            also click on number to zoom in on that area of map.
        </p>
        <p>
            <img
                src="http://maps.google.com/mapfiles/kml/paddle/wht-stars.png"
                alt="marker"
                width={20}
            />
            shows location of event venue on the map.
        </p>
        <p>
            Note: Customers who have already purchased tickets to this event are
            included in this data.
        </p>
    </div>
)

const GetLocationsWidget = ({ eventId, startDate, endDate, event }) => (
    <div>
        <Subtitle title="Where are your known visitors?" tooltip={tooltip} />
        <Box>
            <Chart eventId={eventId} startDate={startDate} endDate={endDate} event={event} />
        </Box>
    </div>
)

export default GetLocationsWidget
